import "./App.css";
import { useEffect, useState } from "react";
import Login from "./Login";

function App() {
  const [student, setStudent] = useState("");

  useEffect(() => {
    const savedStudent = localStorage.getItem("brightPathwayStudent");
    if (savedStudent) {
      setStudent(savedStudent);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("brightPathwayStudent");
    setStudent("");
  };

  const games = [
    {
      title: "Sight Word Sprint",
      desc: "Race to pick the correct sight word before time runs out.",
      icon: "⚡",
    },
    {
      title: "Word Match",
      desc: "Match sight words to pictures or sentences.",
      icon: "🎯",
    },
    {
      title: "Sentence Builder",
      desc: "Build fun sentences using grade-level words.",
      icon: "🧩",
    },
    {
      title: "Memory Flip",
      desc: "Flip cards and find matching sight words.",
      icon: "🃏",
    },
    {
      title: "Spelling Trail",
      desc: "Spell your way down the path to win.",
      icon: "🌈",
    },
    {
      title: "Reading Quest",
      desc: "Complete reading challenges and level up.",
      icon: "📚",
    },
  ];

  const grades = [
    { label: "Pre-K", icon: "🧸" },
    { label: "K", icon: "⭐" },
    { label: "1st", icon: "🍎" },
    { label: "2nd", icon: "🎈" },
    { label: "3rd", icon: "🖍️" },
    { label: "4th", icon: "📘" },
    { label: "5th", icon: "🚀" },
    { label: "6th", icon: "🏆" },
  ];

  if (!student) {
    return <Login onLogin={setStudent} />;
  }

  return (
    <div className="site">
      <header className="hero">
        <div className="hero-overlay"></div>

        <div className="top-bar">
          <div className="welcome-pill">
            👋 Welcome, <strong>{student}</strong>
          </div>

          <button className="logout-button" onClick={handleLogout}>
            Log Out
          </button>
        </div>

        <div className="hero-content">
          <p className="hero-badge">✨ Learn • Play • Grow ✨</p>
          <h1>Bright Pathway</h1>
          <p className="hero-text">
            A colorful learning world filled with games, reading fun, and
            exciting grade-level adventures for kids.
          </p>
          <button className="hero-main-button">Start Playing</button>
        </div>
      </header>

      <section className="section">
        <div className="section-heading">
          <h2>Choose Your Grade Level</h2>
          <p>Pick the level that matches your learning journey.</p>
        </div>

        <div className="grid">
          {grades.map((grade) => (
            <div className="card grade-card" key={grade.label}>
              <div className="emoji">{grade.icon}</div>
              <h3>{grade.label}</h3>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <h2>Fun Learning Games</h2>
          <p>Explore exciting activities made to help kids build skills.</p>
        </div>

        <div className="grid">
          {games.map((game) => (
            <div className="card game-card" key={game.title}>
              <div className="emoji large-emoji">{game.icon}</div>
              <h3>{game.title}</h3>
              <p>{game.desc}</p>
              <button className="card-button">Play Now</button>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="reward-banner">
          <h2>🌟 Earn Stars, Grow Skills, Have Fun! 🌟</h2>
          <p>
            Bright Pathway helps kids learn with confidence through games,
            practice, and playful progress.
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;
